import { VirtualKeypadDriver } from '../drivers/VirtualKeypadDriver';
import { AstxKeypadDriver } from '../drivers/AstxKeypadDriver';
// import { createNativeSecureKeypadDriver } from '../drivers/NativeKeypadDriver';
import { SecureKeypadContext, SecureKeypadDriver } from '../types/types';
import { NativeKeypadDriver } from '../drivers/NativeKeypadDriver';

export class SecureKeypadManager {
  private drivers: SecureKeypadDriver[];

  /**
   * 생성자
   * @param drivers
   */
  constructor(drivers: SecureKeypadDriver[]) {
    this.drivers = drivers;
  }

  /**
   * 사용가능한 보안키패드 드라이버를 획득한다.
   * @param ctx 보안키패드 컨텍스트
   * @returns
   */
  resolveDriver(
    ctx: SecureKeypadContext,
    subCtx?: SecureKeypadContext,
  ): SecureKeypadDriver | undefined {
    const driver = this.drivers.find((d) => d.supported(ctx));
    if (!driver) {
      return;
    }

    if (subCtx && driver.supported(subCtx)) {
      const subDriver = this.drivers.find((d) => d.supported(subCtx));

      if (driver === subDriver) {
        driver?.init({
          ...ctx,
          options: [...(ctx?.options ?? []), ...(subCtx?.options ?? [])],
        });

        return driver;
      }
    }

    driver?.init(ctx);

    return driver;
  }
}

export const secureKeypadManager = () => {
  return new SecureKeypadManager([
    new VirtualKeypadDriver(),
    new AstxKeypadDriver(),
    new NativeKeypadDriver(),
  ]);
};
